import React from "react";
import { Switch, Route } from "react-router-dom";

import PaymentTermsPage from "./PaymentTermsPage";

const PaymentTermsRouter = () => (
  <Switch basepath="/finance/payment-terms">
    <Route path="/finance/payment-terms">
      <PaymentTermsPage />
    </Route>
  </Switch>
);

export default PaymentTermsRouter;
